import { setLocaleObjectNamespace } from "../../../common/src/setLocaleObjectNamespace";

export default setLocaleObjectNamespace("program", {
    'view.types': 'Вид отображения (раскладка)',
    'view.tiles': 'Плиткой',
    'view.lines': 'Списком',
    'view.grid': 'Сеткой',
    'view.tabs': 'Вкладками',
    'view.hide': 'Не отображать',
    'view.page': 'Списком на странице',
    'days.view': 'Отображение дней',
    'halls.view': 'Отображение залов',
    'members.photo.show': 'Показывать фотографии участников в сетке',
    'calendar.buttons.show': 'Показывать кнопки Добавить в календарь',
    'watchRecording.button.show': 'Показывать кнопку Смотреть запись',
    'settings.view': 'Настройка отображения', 
    'settings.tiles': 'Настройка отображения плитками',
    'settings.lines': 'Настройка отображения списком',
    'settings.timelines': 'Интервалы отображения времени',
    'time.minutes': '{minutes} мин.',
    'time.without.interval': 'Без интервала',
    'description.show': 'Разворачивать описание всех докладов по умолчанию',
    'modals.show': 'Показывать модальные окна в программах',
});
